import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { environment } from '../../environments/environment';

function buildRedirectUrl(domain: string | null | undefined, route: ActivatedRouteSnapshot): string {
  const trimmedDomain = domain != null ? domain.trim().replace(/\/+$/, '') : '';
  const childPath = route.url.map((u) => u.path).join('/');
  const path = 'brew' + (childPath ? '/' + childPath : '');

  const searchParams = new URLSearchParams();
  for (const [key, value] of Object.entries(route.queryParams)) {
    if (Array.isArray(value)) {
      value.forEach((entry) => searchParams.append(key, entry));
    } else if (value != null) {
      searchParams.append(key, value);
    }
  }
  const queryString = searchParams.toString();

  return trimmedDomain + '/' + path + (queryString ? '?' + queryString : '');
}

export const brewRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  window.location.href = buildRedirectUrl(environment.reactFrontendDomain, route);
  return false;
};
